import React from "react";
import { Box, Typography, Breadcrumbs, Link as MuiLink } from "@mui/material";
import { Link } from "react-router-dom";

/**
 * Consistent page intro for content/SEO pages.
 */
const PageHero = ({
    eyebrow,
    title,
    subtitle,
    breadcrumbs = [],
}) => (
    <Box sx={{ mb: { xs: 4, md: 5 }, textAlign: { xs: "center", md: "left" } }}>
        {breadcrumbs.length > 0 && (
            <Breadcrumbs
                aria-label="breadcrumb"
                sx={{
                    mb: 2,
                    justifyContent: { xs: "center", md: "flex-start" },
                    display: "flex",
                    "& .MuiBreadcrumbs-ol": {
                        justifyContent: { xs: "center", md: "flex-start" },
                    },
                }}
            >
                {breadcrumbs.map((crumb, i) =>
                    crumb.to ? (
                        <MuiLink
                            key={i}
                            component={Link}
                            to={crumb.to}
                            underline="hover"
                            color="inherit"
                            sx={{ fontSize: "0.875rem" }}
                        >
                            {crumb.label}
                        </MuiLink>
                    ) : (
                        <Typography key={i} color="text.primary" sx={{ fontSize: "0.875rem" }}>
                            {crumb.label}
                        </Typography>
                    )
                )}
            </Breadcrumbs>
        )}
        {eyebrow && (
            <Typography
                variant="overline"
                sx={{
                    color: "primary.main",
                    fontWeight: 700,
                    letterSpacing: 1.2,
                    display: "block",
                    mb: 1,
                }}
            >
                {eyebrow}
            </Typography>
        )}
        <Typography
            variant="h1"
            component="h1"
            sx={{
                fontSize: { xs: "2rem", md: "2.75rem" },
                fontWeight: 700,
                mb: 2,
                lineHeight: 1.15,
                background: "linear-gradient(135deg, #2C3E2D 0%, #2E8B57 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
            }}
        >
            {title}
        </Typography>
        {subtitle && (
            <Typography
                variant="body1"
                sx={{
                    fontSize: { xs: "1.05rem", md: "1.125rem" },
                    lineHeight: 1.75,
                    color: "text.secondary",
                    maxWidth: 760,
                    mx: { xs: "auto", md: 0 },
                }}
            >
                {subtitle}
            </Typography>
        )}
    </Box>
);

export default PageHero;
